export const RESET_REDUX_STORE = 'resetReduxStore';
export const LEAVE_PAGE_TRUE = 'leavePageTrue';
